import {
  params,
  string,
  shape,
  bool,
  number
} from '@thd-nucleus/data-sources';

export const dataModel = {
  techShedReviews: params(
    {
      serviceIdentifier: string().isRequired(),
      size: number(),
      from: number(),
      zipcode: string(),
      sort: string()
    }).shape({
    total: number(),
    count: number(),
    reviews: shape({
      title: string(),
      body: string(),
      rating: string(),
      userName: string(),
      createdTime: string(),
      isRecommended: bool(),
      isVerifiedInstall: bool(),

    }),
    aggregation: shape({
      minReviewRating: number(),
      maxReviewRating: number(),
      averageReviewRating: number(),
      recommendationCount: number(),
      reviewRatingDistribution: number()
    })

  })
};